import { render, staticRenderFns } from "./ControlInputVal.vue?vue&type=template&id=6ffa90fb&scoped=true"
import script from "./ControlInputVal.vue?vue&type=script&lang=js"
export * from "./ControlInputVal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa90fb",
  null
  
)

export default component.exports